
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"110","height":"36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".25","y":".25","width":"109.5","height":"35.5","rx":"7.75","fill":"#fff","stroke":"#AEB1BA","stroke-width":".5"}}),_c('path',{attrs:{"d":"M78.272 18.707a1 1 0 000-1.414l-6.364-6.364a1 1 0 00-1.414 1.414L76.15 18l-5.656 5.657a1 1 0 101.414 1.414l6.364-6.364zM32.436 19h45.129v-2H32.437v2z","fill":"#AEB1BA"}})])
          )
        }
      }
    